import { Conditional, useBreakpoint } from '@cat-ecom/pcc-components';
import {
  CONTACT_CONTAINER,
  DATE_TIME_CONTAINER,
  DESCRIPTION_CONTAINER,
  REFERENCE_TYPE
} from '../constant';
import { PAGE_BREAKPOINTS } from 'constants/common';
import { useTranslations } from 'next-intl';
import { useMemo } from 'react';
import styles from '../request-equipment-service.module.scss';
import { RequestEquipmentServiceBodyProps } from '../types';
import RequestEquipmentServiceNotificationBanner from '../request-equipment-service-notification-banner';
import RequestEquipmentServiceSearch from '../request-equipment-service-search';
import RequestEquipmentServiceDealerInfo from '../request-equipment-service-dealer-info';
import RequestEquipmentServiceDateTime from '../request-equipment-service-date-time';
import RequestEquipmentServiceContactMethod from '../request-equipment-service-contact-method';
import RequestEquipmentServiceEquipmentInfo from '../request-equipment-service-equipment-info';
import RequestEquipmentServiceDescription from '../request-equipment-service-description';

const RequestEquipmentServiceBody = ({
  equipmentDetail,
  dealerName,
  onDealerChange,
  dealerList,
  activeIndex,
  fullWidth,
  existingServices,
  equipmentList,
  type = REFERENCE_TYPE.GENERAL,
  setDismissNotification,
  dismissNotification
}: Readonly<RequestEquipmentServiceBodyProps>) => {
  const isMd = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const t = useTranslations();
  const { serviceInfo, customerInfo } = existingServices || {};
  const { submittedTime, dealerName: serviceDealerName } = serviceInfo || {};
  const { contactName } = customerInfo || {};
  const hasSelectedEquipment = !!equipmentDetail.model;
  const dateTabs = useMemo(
    () => [
      {
        tabName: t('FIRST_AVAILABLE'),
        ariaLabel: 'first-available',
        classname: styles['preferred-date-wrapper__first-available-tab']
      },
      {
        tabName: t('REG_BIRTHDAY_DATE'),
        ariaLabel: 'date',
        classname: styles['preferred-date-wrapper__date-tab']
      }
    ],
    [t]
  );
  const showNotificationBanner = !!serviceInfo && !dismissNotification;
  return (
    <>
      <Conditional test={showNotificationBanner}>
        <RequestEquipmentServiceNotificationBanner
          dealerName={serviceDealerName}
          contactName={contactName}
          submittedDate={submittedTime}
          setDismissNotification={setDismissNotification}
          dismissNotification={dismissNotification}
        />
      </Conditional>
      <Conditional test={type === REFERENCE_TYPE.TECH_UPGRADE}>
        <RequestEquipmentServiceSearch
          placeholder={t('RS_EQUIPMENT_SEARCH_FIELD')}
          hasNotSelectedEquipment={!hasSelectedEquipment}
          equipmentList={equipmentList}
        />
      </Conditional>
      <Conditional test={hasSelectedEquipment}>
        <RequestEquipmentServiceEquipmentInfo
          equipmentDetail={equipmentDetail}
        />
      </Conditional>
      <Conditional test={activeIndex === DESCRIPTION_CONTAINER || isMd}>
        <RequestEquipmentServiceDealerInfo
          dealerName={dealerName}
          onDealerChange={onDealerChange}
          dealerList={dealerList}
          isMD={isMd}
        />
        <RequestEquipmentServiceDescription
          isMobile={fullWidth}
          classname={styles['request-service__show-input__rectangle-dot']}
        />
      </Conditional>
      <Conditional test={activeIndex === DATE_TIME_CONTAINER || isMd}>
        <RequestEquipmentServiceDateTime
          isMobile={!isMd}
          classname={styles['request-service__date-time__rectangle-dot']}
          tabs={dateTabs}
        />
      </Conditional>
      <Conditional test={activeIndex === CONTACT_CONTAINER || isMd}>
        <RequestEquipmentServiceContactMethod
          isMobile={!isMd}
          classname={styles['request-service__contact-method__rectangle-dot']}
        />
      </Conditional>
    </>
  );
};

export default RequestEquipmentServiceBody;
